import React, {useState, useEffect} from "react";
import { useVsiAppContext} from "../../../../stores/VsiApp";
import {useSearchParams} from "react-router-dom";
import {getReport} from "../../../../utils/Verbs";
import Grid from "../../../../components/Grid";
import {VsiBubble, VsiH4} from "../../../../styled/App.styled";
import {useTitleFromComponent} from "../../../../utils/hooks";
import {Card} from "reactstrap";

const detailDefs = [
    // {
    // 	"field": "collection_date",
    // 	"headerName": "Collection Date",
    // 	"cellRenderer": "dateOnlyFormatter",
    // 	"enableRowGroup": true,
    // 	"hide": true,
    // },
    // {
    // 	"field": "device_name",
    // 	"headerName": "Array Name",
    // 	"enableRowGroup": true,
    // 	"hide": true
    // },
    // {
    // 	"field": "wwn",
    // 	"type": "numericColumn",
    // 	"headerName": "Drive Type",
    // 	"enableRowGroup": true,
    // 	"hide": true
    // },
    {
        "field": "setting_key",
        "headerName": "Setting",
    },
    {
        "field": "setting_value",
        "headerName": "Value",
        "enableRowGroup": true
    }
];

export default function DeviceAdditionalDetails({context, title}) {

    const [searchParams] = useSearchParams();
    useTitleFromComponent(`${searchParams.get('device_name')} / ${title}`);
    const [isLoading, setIsLoading] = useState(true);
    const [detailData, setDetailData] = useState([]);

    const { theme, client, periodId, user, getAccessTokenSilently } = useVsiAppContext();

    useEffect(() => {
        const getAddtlDetails = async function () {
            const device_name = searchParams.get('device_name');
            const route = `/api/v6/report/device_additional_details_proc?client_id=${client.clientId}&period_id=${periodId}&device_name=${device_name}`;
            try {
                const token = await getAccessTokenSilently();
                const data = await getReport(route, null, token);
                setDetailData(data?.data?.recordset || []);
                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);
            }
        };
        getAddtlDetails();
    }, [searchParams])

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Additional Details - {searchParams.get('device_name')}</VsiH4>
        <VsiBubble>
            <Grid data={detailData} columnDefs={detailDefs} isLoading={isLoading}/>
        </VsiBubble>
    </Card>
}
